import Alerts from "../util/Alerts";
import { Card } from "reactstrap";
import React, { useEffect, useState } from "react";
import { CarouselJedai } from "../coms/CarouselJedai";
import axios from "axios";
import { routes } from "./General";

export const Home = () => {
    const [banner, setBanner] = useState([]);
    const alert = React.useRef();

    useEffect(() => {
        obtenerBanner();
    }, []);

    const obtenerBanner = () => {
        axios
            .get(routes.apiVam + "/banner/obtener/banner")
            .then(resp => {
                setBanner(resp.data.itemsGen);
            })
            .catch(err => {
                // alert.current.show_error('Error al consultar' + err);
            });
    };

    return (
        <div className="content">
            <Alerts ref={alert} />
            <Card className="home-slider">
                <CarouselJedai items={banner} />
            </Card>
        </div>
    );
};
